module.exports = __webpack_public_path__ + "img/location_marker.7d77dbab.png";